import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Combobox, Icon } from '@node-space/ui-components'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { useMappedRoles } from 'hooks/useMappedRoles'
import { useCurrenciesOptions } from '../hooks/useCurrenciesOptions'
import { useCurrency } from '../hooks/useCurrency'
import { useUserCurrentCurrency } from '../hooks/useUserCurrentCurrency'
import { DetailsRow } from './DetailsRow'

export const DisplayPreferences = () => {
  const { t } = useTranslation()

  const { profile } = useProfileContext() || {}
  const { language } = profile || {}
  const permissions = useMappedRoles()?.profile
  const canEdit = permissions?.canEdit

  const {
    isCurrencyEditing,
    setCurrency,
    isChangingCurrency,
    handleSaveCurrency,
    setIsCurrencyEditing,
  } = useCurrency()

  const userCurrency = useUserCurrentCurrency()
  const { currencyOptions, isCurrenciesLoading } = useCurrenciesOptions()

  return (
    <Box flexCol gapY={24}>
      <Box tag="h2" className="text-lg font-semibold text-gray-900">
        {t('account.displayPreferences')}
      </Box>
      <Box flexCol gapY={16}>
        <DetailsRow label={t('language')}>{language || 'English'}</DetailsRow>

        <Box flex gapX={16} className="items-end w-full md:w-auto">
          <Box className="flex-1">
            <Combobox
              disabled={!isCurrencyEditing}
              id="currency"
              testId="currency-combobox"
              loading={isCurrenciesLoading}
              label={t('currency')}
              items={currencyOptions}
              onChange={currency => {
                setCurrency(currency)
              }}
              defaultValue={userCurrency}
            />
          </Box>

          <Button
            variant="primary"
            data-testid="change-currency-button"
            disabled={!canEdit}
            iconElement={<Icon name="SimplePencilCustom" />}
            loading={isChangingCurrency}
            onClick={() => (isCurrencyEditing ? handleSaveCurrency() : setIsCurrencyEditing(true))}
          >
            {isCurrencyEditing ? t('save') : t('change')}
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
